/** One byte budget across all animation frames. Map insertion order is the LRU. */
export class RadarTileCache {
  private entries = new Map<string, ImageData>();
  private bytes = 0;
  constructor(readonly maxBytes = 32 * 1024 * 1024) {}

  get(key: string): ImageData | undefined {
    const image = this.entries.get(key);
    if (image) {
      this.entries.delete(key);
      this.entries.set(key, image);
    }
    return image;
  }
  set(key: string, image: ImageData): void {
    const previous = this.entries.get(key);
    if (previous) {
      this.bytes -= previous.data.byteLength;
      this.entries.delete(key);
    }
    if (image.data.byteLength > this.maxBytes) return;
    while (this.bytes + image.data.byteLength > this.maxBytes) {
      const oldest = this.entries.entries().next().value;
      if (!oldest) break;
      this.entries.delete(oldest[0]);
      this.bytes -= oldest[1].data.byteLength;
    }
    this.entries.set(key, image);
    this.bytes += image.data.byteLength;
  }
  clear(): void {
    this.entries.clear();
    this.bytes = 0;
  }
  usage(prefix = ""): { cachedTiles: number; cachedBytes: number } {
    let cachedTiles = 0,
      cachedBytes = 0;
    for (const [key, image] of this.entries)
      if (key.startsWith(prefix)) {
        cachedTiles++;
        cachedBytes += image.data.byteLength;
      }
    return { cachedTiles, cachedBytes };
  }
}
